<template>
    <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
    <label class="k-c-label text-gray-600">
        <slot/>
    </label>
</template>
